var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('a', {
    attrs: {
      "id": "subscriptions"
    }
  }), _c('h2', {
    staticClass: "text-h5 text-center mb-3"
  }, [_vm._v("Unlimited subscriptions")]), _c('pricing-subscriptions', {
    on: {
      "purchase": function ($event) {
        return _vm.$router.push({
          name: 'account'
        });
      }
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('a', {
    attrs: {
      "id": "bulk-packs"
    }
  }), _c('h2', {
    staticClass: "text-h5 text-center mb-3"
  }, [_vm._v("Bulk packs")]), _c('pricing-bulk-packs', {
    on: {
      "purchase": function ($event) {
        return _vm.$router.push({
          name: 'account'
        });
      }
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10",
      "offset-md": "1"
    }
  }, [_c('div', {
    staticClass: "mt-6 text-h6 text-center"
  }, [_vm._v("We also offer additional tools, features, and discounts for "), _c('router-link', {
    attrs: {
      "to": {
        name: 'business'
      }
    }
  }, [_vm._v("businesses / organizations")])], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }